import { Controller } from "@hotwired/stimulus"

// Per-crop pricing basis toggle inside the harvest cycle form. Each crop
// section gets its own controller instance switching between the per-kg
// input and the per-unit price grid.
export default class extends Controller {
  static targets = ["basisRadio", "kgPanel", "unitPanel"]

  connect() {
    this.basisChanged()
  }

  basisChanged() {
    const basis = this.basisRadioTargets.find((radio) => radio.checked)?.value
    const perKg = basis !== "per_harvest_unit"
    this.kgPanelTarget.classList.toggle("hidden", !perKg)
    this.unitPanelTarget.classList.toggle("hidden", perKg)
  }
}
